import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { DownloadAppBanner } from '../../components/DownloadAppBanner';
import { selectDownloadAppBannerDisabled } from '../../selectors/downloadAppBanner';
import { selectEventCategory } from '../../selectors/eventCategory';
import { IApplicationState } from '../../types/redux';
import { trackDownloadAppClick, trackMobileAppClick } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { MOBILE_BANNER_TITLE } from './constants';

export const DownloadAppBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const platform = useSelector((state: IApplicationState) => state.platform);
  const isDownloadAppBannerDisabled = useSelector(selectDownloadAppBannerDisabled);
  const eventCategory = useSelector(selectEventCategory);

  const [url, setUrl] = React.useState<string | null>(config.get<string>('mobileBanner.browserUrl') || null);

  React.useEffect(() => {
    setUrl(generateOneLinkUrl(url, 'mobile_site', MOBILE_BANNER_TITLE));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadAppClick = () => {
    trackDownloadAppClick({ category: eventCategory, platform });
  };

  const handleMobileAppClick = () => {
    trackMobileAppClick();
  };

  if (isDownloadAppBannerDisabled || !platform || !url) {
    return null;
  }

  return (
    <DownloadAppBanner
      url={url}
      platformType={platform}
      onDownloadAppClick={handleDownloadAppClick}
      onMobileAppClick={handleMobileAppClick}
    />
  );
};
